var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'hab-tabs',
    {
      [`${_vm.className}`]: _vm.className,
    },
  ]},[_c('div',{staticClass:"hab-tabs-heade"},_vm._l((_vm.dataSource),function(tab,index){return _c('span',{key:index,class:['item', { active: _vm.active === _vm.get(tab, 'value', '') }],on:{"click":() => _vm.onTabs(tab)}},[_vm._v(_vm._s(_vm.get(tab, 'name', '')))])}),0),_vm._v(" "),_c('div',{staticClass:"hab-tabs-contents"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }